// Libraries
import React from 'react';

// Components
import { Page } from 'components/Page';
import { H1 } from 'components/Typography';
// Styles
import styles from './Contacts.module.scss';

const Contacts = (): React.ReactElement<typeof Page> => (
  <Page
    classes={{
      root: styles.Root,
      container: styles.Container
    }}
  >
    <H1>
      Контакты
    </H1>
  </Page>
);

// Exports
export default Contacts;
